/*
 * @创建文件时间: 2020-02-14 10:48:38
 * @最后修改人: lfq
 * @最后修改时间: 2020-03-18 17:10:20
 * @联系Qq:1360484677
 * @文件介绍: 桥隧涵检查数据
 */
export default [{
        path: 'bridgeRegularCheck',
        name: 'bridgeRegularCheck',
        meta: {
            title: '桥梁定期检查记录',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/bTCChecks/bridgeTunnelCulvertData/bridgeRegularCheck')
    }, {
        path: 'bridgeRunningCheck',
        name: 'bridgeRunningCheck',
        meta: {
            title: '桥梁经常检查记录',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/bTCChecks/bridgeTunnelCulvertData/bridgeRunningCheck')
    }, {
        path: 'bridgeSpecialCheck',
        name: 'bridgeSpecialCheck',
        meta: {
            title: '桥梁特殊检查记录',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/bTCChecks/bridgeTunnelCulvertData/bridgeSpecialCheck')
    }, {
        path: 'culvertRegularCheck',
        name: 'culvertRegularCheck',
        meta: {
            title: '涵洞定期检查记录',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/bTCChecks/bridgeTunnelCulvertData/culvertRegularCheck')
    }, {
        path: 'culvertRunningCheck',
        name: 'culvertRunningCheck',
        meta: {
            title: '涵洞经常检查数据',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/bTCChecks/bridgeTunnelCulvertData/culvertRunningCheck')
    }, {
        path: 'tunnelFacilityFault',
        name: 'tunnelFacilityFault',
        meta: {
            title: '隧道机电设施故障信息',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/bTCChecks/bridgeTunnelCulvertData/tunnelFacilityFault')
    }, {
        path: 'tunnelSpecialCheck',
        name: 'tunnelSpecialCheck',
        meta: {
            title: '隧道专项检查纪录',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/bTCChecks/bridgeTunnelCulvertData/tunnelSpecialCheck')
    }, {
        path: 'tunnelRegularCheck',
        name: 'tunnelRegularCheck',
        meta: {
            title: '隧道定期检查纪录',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/bTCChecks/bridgeTunnelCulvertData/tunnelRegularCheck')
    }, {
        path: 'tunnelRunningCheck',
        name: 'tunnelRunningCheck',
        meta: {
            title: '隧道经常检查纪录',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/bTCChecks/bridgeTunnelCulvertData/tunnelRunningCheck')
    }, {
        path: 'handoverAcptApply',
        name: 'handoverAcptApply',
        meta: {
            title: '交工验收申请单',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/bTCChecks/bridgeTCMaintenance/handoverAcptApply')
    }, {
        path: 'completedAcptBehaifList',
        name: 'completedAcptBehaifList',
        meta: {
            title: '竣工验收代表名单',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/bTCChecks/bridgeTCMaintenance/completedAcptBehaifList')
    }, {
        path: 'completedAcptCommitteeList',
        name: 'completedAcptCommitteeList',
        meta: {
            title: '竣工验收委员会名单',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/bTCChecks/bridgeTCMaintenance/completedAcptCommitteeList')
    }, {
        path: 'completedAcptCommitteeQs',
        name: 'completedAcptCommitteeQs',
        meta: {
            title: '竣工验收委员会工程质量评分表',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/bTCChecks/bridgeTCMaintenance/completedAcptCommitteeQs')
    }, {
        path: 'completedAcptEr',
        name: 'completedAcptEr',
        meta: {
            title: '竣工验收鉴定书',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/bTCChecks/bridgeTCMaintenance/completedAcptEr')
    }, {
        path: 'completedAcptQsAssessment',
        name: 'completedAcptQsAssessment',
        meta: {
            title: '竣工验收工程质量评价表',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/bTCChecks/bridgeTCMaintenance/completedAcptQsAssessment')
    }, {
        path: 'completedAcptQsAssessmentB',
        name: 'completedAcptQsAssessmentB',
        meta: {
            title: '竣工验收项目综合评定表',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/bTCChecks/bridgeTCMaintenance/completedAcptQsAssessmentB')
    }, {
        path: 'projectCa',
        name: 'projectCa',
        meta: {
            title: '项目建设管理综合评价',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/bTCChecks/bridgeTCMaintenance/projectCa')
    }, {
        path: 'projectConstructCa',
        name: 'projectConstructCa',
        meta: {
            title: '施工管理综合评价表',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/bTCChecks/bridgeTCMaintenance/projectConstructCa')
    }, {
        path: 'projectDesignCa',
        name: 'projectDesignCa',
        meta: {
            title: '设计工作综合评价表',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/bTCChecks/bridgeTCMaintenance/projectDesignCa')
    }, {
        path: 'projectSupervisingCa',
        name: 'projectSupervisingCa',
        meta: {
            title: '监理工作综合评价表',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/bTCChecks/bridgeTCMaintenance/projectSupervisingCa')
    },



    {
        path: 'btreinReportMaintainPlan',
        name: 'btreinReportMaintainPlan',
        meta: {
            title: '维修计划上报',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/bridgeTCMaintenance/wxzxReportMaintainPlan')
    }, {
        path: 'btreinMaintainProDesign',
        name: 'btreinMaintainProDesign',
        meta: {
            title: '维修工程设计',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/bridgeTCMaintenance/wxzxMaintainProDesign')
    },
    {
        path: 'btreinDesignChangeTable',
        name: 'btreinDesignChangeTable',
        meta: {
            title: '维修设计变更',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/bridgeTCMaintenance/wxzxDesignChangeTable')
    },
    {
        path: 'btreinMonthPay',
        name: 'btreinMonthPay',
        meta: {
            title: '维修工作计量月报',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/bridgeTCMaintenance/wxzxMonthPay')
    },
    {
        path: 'btreinQualityJobUnitTable',
        name: 'btreinQualityJobUnitTable',
        meta: {
            title: '质量责任卡承包单位',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/bridgeTCMaintenance/wxzxQualityJobUnitTable')
    },
    {
        path: 'btreinListingPaymentTable',
        name: 'btreinListingPaymentTable',
        meta: {
            title: '清单期中支付',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/bridgeTCMaintenance/wxzxListingPaymentTable')
    },
    {
        path: 'btreinProQsAfterEvaluateTable',
        name: 'btreinProQsAfterEvaluateTable',
        meta: {
            title: '工程质量后评价',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/bridgeTCMaintenance/wxzxProQsAfterEvaluateTable')
    },
    {
        path: 'btreinAcceptApplyTable',
        name: 'btreinAcceptApplyTable',
        meta: {
            title: '交工验收申请',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/bridgeTCMaintenance/wxzxAcceptApplyTable')
    },
    {
        path: 'btreinAcceptApply',
        name: 'btreinAcceptApply',
        meta: {
            title: '交工验收申请',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/bridgeTCMaintenance/wxzxAcceptApply')
    },
    {
        path: 'btreinProApplyCertificatTable',
        name: 'btreinProApplyCertificatTable',
        meta: {
            title: '维修工程交工验收证书',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/bridgeTCMaintenance/wxzxProApplyCertificatTable')
    },
    {
        path: 'btreinDelyworkAcceptConTable',
        name: 'btreinDelyworkAcceptConTable',
        meta: {
            title: '维修工程交工验收报告',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/bridgeTCMaintenance/wxzxDelyworkAcceptConTable')
    },
    {
        path: 'btreinQualityScoreTable',
        name: 'btreinQualityScoreTable',
        meta: {
            title: '交工验收工程质量评分',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/bridgeTCMaintenance/wxzxQualityScoreTable')
    },
    {
        path: 'btreinImEvaluateTable',
        name: 'btreinImEvaluateTable',
        meta: {
            title: '管理综合评价表',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/bridgeTCMaintenance/wxzxImEvaluateTable')
    },
    {
        path: 'btreinDesignWorkCeTable',
        name: 'btreinDesignWorkCeTable',
        meta: {
            title: '设计工作综合评价表',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/bridgeTCMaintenance/wxzxDesignWorkCeTable')
    },
    {
        path: 'btreinSuperviseCeTable',
        name: 'btreinSuperviseCeTable',
        meta: {
            title: '监理工作综合评价表',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/bridgeTCMaintenance/wxzxSuperviseCeTable')
    },
    {
        path: 'btreinCmceTable',
        name: 'btreinCmceTable',
        meta: {
            title: '施工管理综合评价表',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/bridgeTCMaintenance/wxzxCmceTable')
    },
    {
        path: 'btreinCompletedQgTable',
        name: 'btreinCompletedQgTable',
        meta: {
            title: '竣工验收委员会工程质量评分表',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/bridgeTCMaintenance/wxzxCompletedQgTable')
    },
    {
        path: 'btreinCaCertificateTable',
        name: 'btreinCaCertificateTable',
        meta: {
            title: '维修工程竣工验收鉴定书',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/bridgeTCMaintenance/wxzxCaCertificateTable')
    },
    {
        path: 'btreinCompletedQeTable',
        name: 'btreinCompletedQeTable',
        meta: {
            title: '竣工验收工程质量评价表',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/bridgeTCMaintenance/wxzxCompletedQeTable')
    },
    {
        path: 'btreinComplatedCeTable',
        name: 'btreinComplatedCeTable',
        meta: {
            title: '竣工验收项目综合评定表',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/bridgeTCMaintenance/wxzxComplatedCeTable')
    }
]